import { makeVar } from "@apollo/client";

/**
 * Status of an in-flight or settled Transfermarkt URL player lookup
 */
export type TransfermarktLookupStatus = "idle" | "loading" | "notFound";

/**
 * State of the Transfermarkt URL player lookup, bridged from the shared
 * mobile Searchbar (which owns the input) to the screens that render the
 * search results and empty states (e.g. the /search tab MainContainer).
 */
export interface TransfermarktLookupState {
  status: TransfermarktLookupStatus;
  transfermarktId: number | null;
}

export const defaultTransfermarktLookup: TransfermarktLookupState = {
  status: "idle",
  transfermarktId: null,
};

export const transfermarktLookupVar = makeVar<TransfermarktLookupState>(
  defaultTransfermarktLookup
);
